module.exports = __webpack_public_path__ + "img/mod_8.0b493b91.png";